import {
  Toolbar,
  SaveButton,
  List,
  SimpleForm,
  DateInput,
  DateField,
  TextInput,
  Datagrid,
  Edit,
  Create,
  TextField,
  ReferenceField,
  ReferenceInput,
  NumberInput,
  NumberField,
  SelectInput,
  required,
  Show,
  SimpleShowLayout,
  ReferenceManyField,
  FormDataConsumer,
  ReferenceArrayInput,
  SelectArrayInput,
  BooleanInput,
  BooleanField,
  ArrayField,
  useNotify,
  useRefresh,
  useDataProvider,
} from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'
import {
  EmptyActions,
  CustomToolbar,
  CustomToolbarOnlyDelete,
  ExtraPagination,
} from './utils'
import Chip from '@material-ui/core/Chip'
import { Button } from '@material-ui/core'

export const TagsList = (props) => (
  <List
    bulkActionButtons={false}
    exporter={false}
    pagination={<ExtraPagination />}
    {...props}
  >
    <Datagrid rowClick="edit">
      <NumberField source="id" label="N°" />
      <TextField source="title" label="Titre" />
      <DateField source="created" label="Créé le" />
    </Datagrid>
  </List>
)

export const TagEdit = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm variant="outlined">
        <TextInput source="title" label="Titre" validate={[required()]} />
      </SimpleForm>
    </Edit>
  )
}

export const TagCreate = (props) => {
  return (
    <Create {...props}>
      <SimpleForm variant="outlined">
        <TextInput source="title" label="Titre" validate={[required()]} />
      </SimpleForm>
    </Create>
  )
}
